import { useState } from 'react';
import { api, type SearchResults } from '../api';

export function GlobalSearch() {
  const [q, setQ] = useState('');
  const [results, setResults] = useState<SearchResults | null>(null);

  async function run(e: React.FormEvent) {
    e.preventDefault();
    if (q.trim().length < 2) return;
    setResults(await api.get<SearchResults>(`/api/search?q=${encodeURIComponent(q)}`));
  }

  return (
    <div className="search">
      <form onSubmit={run} className="row">
        <input placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} />
        <button className="btn" type="submit">Go</button>
      </form>
      {results && (
        <div className="dropdown">
          <strong>Accounts</strong>
          {results.accounts.map((a) => <div key={a.id} className="notif">{a.name}</div>)}
          <strong>Contacts</strong>
          {results.contacts.map((c) => <div key={c.id} className="notif">{c.fullName ?? c.email}</div>)}
          <strong>Deals</strong>
          {results.deals.map((d) => <div key={d.id} className="notif">{d.name}</div>)}
          {results.accounts.length + results.contacts.length + results.deals.length === 0 && (
            <p className="empty">No matches.</p>
          )}
        </div>
      )}
    </div>
  );
}
